import './main.scss'
import { Starting } from '../static/js/Starting';


const newStart = new Starting();

if(window.location.pathname === '/rejouer.html') {
    newStart.replay()
} else {
    newStart.init()
}